import React, { useState } from "react";
import dummy1 from "../../assets/images/dummy/highlight-1.jpg";
import { X, Calendar } from "lucide-react";
import clockIcon from "../../assets/icons/clock.png";
import { getMediaAsset, getMediaTag, getPoiAsset } from "../../helpers";
import { useStores } from "../../use.store";
import "../../scrollbar.css";
import shareIcon from "../../assets/icons/share.svg";

export default function ModalDetailPoi({
  data,
  onClose,
  config,
  isOpenWayfindingModal,
  startWayfinding,
  setStart,
  setEnd,
}) {
  const { mapStore, mainStore } = useStores();

  return (
    <div className="relative">
      <div className="fixed inset-0 bg-black h-full bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="relative flex flex-col gap-y-4 items-center w-[290px]">
          <div className="flex flex-col h-[450px] bg-[#F1EEE7] relative rounded rounded-2xl shadow-2xl w-full max-w-md mx-auto ">
            <div className="relative">
              <img
                src={getPoiAsset(config, data)}
                className="w-full h-[220px] object-cover object-center rounded-t-2xl"
              />
              <button
                onClick={onClose}
                className="absolute right-2 top-2 w-8 h-8 rounded-full bg-red-500 text-white flex items-center justify-center hover:bg-red-600 transition-colors"
              >
                <X size={16} />
              </button>
            </div>
            <div className="bg-[#F1EEE7] pl-5 pr-2 py-1 flex flex-col  rounded rounded-b-2xl h-[220px] overflow-y-auto custom-scrollbar">
              <div className="flex flex-row justify-between ">
                <span className="text-[20px] mb-2">{data.name}</span>

                {data.url && data.url !== "undefined" && (
                  <a href={data?.url}>
                    <img src={shareIcon} />
                  </a>
                )}
              </div>
              <span className="text-xs text-[#75787BB2]">
                {data.categoryName}
              </span>
              {data.opentime && data.opentime !== "" && (
                <div className="flex flex-row">
                  <img src={clockIcon} className="w-[18px] h-[18px]" />
                  <span className="text-xs text-[#75787BB2]">
                    {data.opentime}
                  </span>
                </div>
              )}

              <span className="text-xs" style={{ whiteSpace: "pre-line" }}>
                {data?.description}
              </span>
            </div>
          </div>

          <button
            className="rounded-xl text-xs z-50 w-[120px] h-[33px] bg-[#A09200] text-white"
            onClick={() => {
              if (!mapStore.destinationShape) {
                setEnd();
                startWayfinding();
                onClose();
              }
              // else if (isOpenWayfindingModal && !mapStore.startShape) {
              //   setStart();
              //   startWayfinding();
              // }
              else if (
                isOpenWayfindingModal &&
                mapStore.destinationShape &&
                mapStore.startShape
              ) {
                startWayfinding();
              } else {
                onClose();
              }
            }}
          >
            {isOpenWayfindingModal ? "Get Direction" : "Select Location"}
          </button>
        </div>
      </div>
    </div>
  );
}
